// @ts-check

import { ROUTE_LAYOUT, ROUTE_NAME } from '@/router/meta'
import { store } from '@/store'
import Layout from '@/views/BaseView.vue'

/**
 * @param {string} path
 * @param {string} name
 * @returns {import('vue-router').RouteRecordRaw}
 */
const constructRoute = (path, name) => ({
  path,
  name,
  component: () =>
    import(
      '@/components/onboarding/oy/companyFounding/CompanyFoundingProcess.vue'
    ),
  beforeEnter: (to, from, next) => {
    /**
     * Besides checking that the process is available in the current environment,
     * we need to check that the company is allowed to access the process
     */
    if (store.getters['companyData/allowedToAccessOyFoundingProcess']) {
      next()
    } else {
      next({ name: 'dashboard', replace: true })
    }
  },
  meta: {
    requiresAuth: true,
    icon: '$account-outline',
    [ROUTE_NAME]: name,
    [ROUTE_LAYOUT]: Layout
  }
})

export const COMPANY_FOUNDING_FOUNDER = {
  path: '/company-founding/founder',
  name: 'company-founding-founder'
}

export const COMPANY_FOUNDING_COMPANY_NAME = {
  path: '/company-founding/company-name',
  name: 'company-founding-company-name'
}

export const COMPANY_FOUNDING_INDUSTRY = {
  path: '/company-founding/industry',
  name: 'company-founding-industry'
}

export const COMPANY_FOUNDING_CONTACT_INFORMATION = {
  path: '/company-founding/contact-information',
  name: 'company-founding-contact-information'
}

export const COMPANY_SHARE_HOLDERS_BOARD_CEO = {
  path: '/company-founding/share-holders-board-ceo',
  name: 'company-founding-share-holders-board-ceo'
}

export const COMPANY_FOUNDING_ACCONTING_PERIOD_AND_TAX = {
  path: '/company-founding/accounting-period',
  name: 'company-founding-accounting-period'
}

export const COMPANY_FOUNDING_REGISTRY_ANNOUNCEMENT = {
  path: '/company-founding/registry-announcement',
  name: 'company-founding-registry-announcement'
}

export const COMPANY_FOUNDING_SUMMARY = {
  path: '/company-founding/summary',
  name: 'company-founding-summary'
}

export const COMPANY_FOUNDING_INFO_SENT = {
  path: '/company-founding/info-sent',
  name: 'company-founding-info-sent'
}

const companyFoundingSubroutes = [
  COMPANY_FOUNDING_FOUNDER,
  COMPANY_FOUNDING_COMPANY_NAME,
  COMPANY_FOUNDING_INDUSTRY,
  COMPANY_FOUNDING_CONTACT_INFORMATION,
  COMPANY_SHARE_HOLDERS_BOARD_CEO,
  COMPANY_FOUNDING_ACCONTING_PERIOD_AND_TAX,
  COMPANY_FOUNDING_REGISTRY_ANNOUNCEMENT,
  COMPANY_FOUNDING_SUMMARY,
  COMPANY_FOUNDING_INFO_SENT
]

export const companyFoundingRoutes = [
  constructRoute('/', ''),
  ...companyFoundingSubroutes.map((route) =>
    constructRoute(route.path, route.name)
  )
]

export default companyFoundingRoutes
